import { timestampDTOSchema } from '@tempo-io/common-dto';
import z from 'zod';

export const publicEmailDomainsSchema = z.enum([
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'protonmail.com',
  'mail.com',
]);

export const publicEmailDomains = publicEmailDomainsSchema.options;

export const samlConnectionDTOSchema = z.object({
  id: z.number(),
  enabled: z.boolean(),
  displayName: z.string().min(1),
  domain: z.string().regex(z.regexes.domain),
  selfServiceTicketUrl: z.url().nullable(),
  isConfigured: z.boolean(),
  isDomainConnection: z.boolean(),
  idpInitiatedLoginEnabled: z.boolean(),
});

export const samlConnectionListItemDTOSchema = samlConnectionDTOSchema.omit({
  selfServiceTicketUrl: true,
});

export const samlConnectionArrayDTOSchema = z.object({
  samlConnections: z.array(samlConnectionListItemDTOSchema),
});

export const samlConnectionCreateDTOSchema = z.object({
  displayName: z.string().min(1),
  isDomainConnection: z.boolean().default(true),
  idpInitiatedLoginEnabled: z.boolean().default(false),
});

export const samlConnectionUpdateDTOSchema = z.object({
  displayName: z.string().min(1),
  isDomainConnection: z.boolean(),
  idpInitiatedLoginEnabled: z.boolean(),
});

export const internalSamlConnectionDTOSchema = z.object({
  id: z.number(),
  organizationId: z.string().nonempty(),
  displayName: z.string(),
  domain: z.string(),
  isConfigured: z.boolean(),
  ...timestampDTOSchema.shape,
});
